"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationSize = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_2 = require("react");
var react_router_dom_1 = require("react-router-dom");
var recoil_1 = require("recoil");
var Styled = __importStar(require("./Navigation.styled"));
var constants_1 = require("@/constants");
var logout_24_svg_1 = __importDefault(require("@/assets/svg/logout-24.svg"));
var store_1 = require("@/store");
exports.NavigationSize = {
    sm: 'sm',
    md: 'md',
};
var Navigation = function (_a) {
    var size = _a.size, inActiveColor = _a.inActiveColor, items = _a.items, _b = _a.showBottomBorder, showBottomBorder = _b === void 0 ? true : _b;
    var pathname = (0, react_router_dom_1.useLocation)().pathname;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var resetMe = (0, recoil_1.useResetRecoilState)(store_1.$me);
    var isMaster = (0, recoil_1.useRecoilValue)(store_1.$isMaster);
    var handleLogout = function () {
        localStorage.removeItem(constants_1.ACCESS_TOKEN);
        resetMe();
        navigate(constants_1.PATH.LOGIN);
    };
    return ((0, jsx_runtime_1.jsxs)(Styled.NavigationContainer, __assign({ showBottomBorder: showBottomBorder }, { children: [items.map(function (item) { return ((0, jsx_runtime_1.jsxs)(react_2.Fragment, { children: [(0, jsx_runtime_1.jsx)(Styled.NavigationTitle, { children: item.title }, void 0), item.menus.map(function (menu, menuIdx) {
                        if (menu.isMasterOnly && !isMaster) {
                            return null;
                        }
                        var isActive = pathname
                            .split('/')
                            .some(function (pathNameItem) { return "/".concat(pathNameItem) === menu.to; });
                        return ((0, jsx_runtime_1.jsxs)(react_2.Fragment, { children: [(0, jsx_runtime_1.jsx)(Styled.ItemWrapper, { children: (0, jsx_runtime_1.jsxs)(Styled.NavigationItem, __assign({ size: size, to: menu.to, inActiveColor: inActiveColor, active: isActive }, { children: [(0, jsx_runtime_1.jsx)(Styled.NavigationIcon, { children: menu.icon }, void 0), menu.label] }), menu.to) }, void 0), item.menus.length === menuIdx + 1 && (0, jsx_runtime_1.jsx)(Styled.NavigationDivider, {}, void 0)] }, menu.label));
                    })] }, item.title)); }), (0, jsx_runtime_1.jsx)(Styled.ItemWrapper, { children: (0, jsx_runtime_1.jsxs)(Styled.LogoutButton, __assign({ size: size, onClick: handleLogout }, { children: [(0, jsx_runtime_1.jsx)(Styled.NavigationIcon, { children: (0, jsx_runtime_1.jsx)(logout_24_svg_1.default, {}, void 0) }, void 0), "\uB85C\uADF8\uC544\uC6C3"] }), void 0) }, void 0)] }), void 0));
};
exports.default = Navigation;
